import { createFileRoute } from '@tanstack/react-router';

import usePersonParams from '@/routes/_staff/person/$id/-hooks/usePersonParams';

import {
  LARGE_CATEGORY_CODES,
  SectionFormWrapper,
  prefetchPeopleLedgerDetail,
} from '../-shared';

export const Route = createFileRoute(
  '/_staff/person/$id/_profile/employee-information/',
)({
  component: EmployeeInformation,
  loader: ({ params }) =>
    prefetchPeopleLedgerDetail(
      params.id,
      LARGE_CATEGORY_CODES.EMPLOYEE_INFORMATION,
    ),
});

const READONLY_SECTION_KEYS: ReadonlySet<string> = new Set([
  'HealthInsurance',
  'PensionInsurance',
  'UnemploymentInsurance',
  'WorkersCompensationInsurance',
  'IncomeTaxInfo',
  'ResidentTaxInfo',
  'CommutingRoute',
  'EmployeeLeaveOfAbsence',
]);

function EmployeeInformation() {
  const { id } = usePersonParams();

  return (
    <SectionFormWrapper
      personId={id}
      largeCategoryCode={LARGE_CATEGORY_CODES.EMPLOYEE_INFORMATION}
      linkTo="/person/$id/employee-information"
      readonlySectionKeys={READONLY_SECTION_KEYS}
    />
  );
}
